<template lang="pug">
  div(class="user-management")
    div(class="user-management__list scroll-y")
      div(class="user-management__title title-normal") 人員管理
      search-bar(class="user-management__searchbar" :placeHolder="'搜尋名字'")
      div
        user-list-item(
          class="user-management__item"
          v-for="(user,index) in getUserData"
          :key="`user-${index}`"
          ref="user"
          :user="user"
          :index="index"
          :selected="index===lastSelectedIndex"
          @click.native="selectUser(user,index)")
    div(class="user-management__info")
      user-info(v-if="selectedUser" :user="selectedUser")
</template>

<script>
import SearchBar from '@/components/SearchBar.vue'
import UserListItem from '@/components/userManagement/UserListItem.vue'
import UserInfo from '@/components/userManagement/UserInfo.vue'
import { mapGetters } from 'vuex'
import gsap from 'gsap'
export default {
  name: 'userManagement',
  components: {
    SearchBar,
    UserListItem,
    UserInfo
  },
  data () {
    return {
      selectedUser: null,
      lastSelectedIndex: null,
      tl: null
    }
  },
  computed: {
    ...mapGetters({
      getUserData: 'getUserData'
    })
  },
  mounted () {
    this.tl = gsap.timeline()
    this.tl.from('.user-management__list', {
      duration: 0.4,
      x: -100
    })
      .from('.user-management__title', {
        duration: 0.4,
        x: -50,
        opacity: 0
      }, '-=0.2')
      .from('.user-management__searchbar', {
        duration: 0.4,
        x: -50,
        opacity: 0
      }, '-=0.2')
      .from('.user-management__item', {
        duration: 0.4,
        x: -50,
        opacity: 0,
        stagger: 0.2
      }, '-=0.2')
  },
  activated () {
    this.tl.restart()
  },
  methods: {
    selectUser (user, index) {
      if (this.selectedUser !== null) {
        this.$refs.user[this.lastSelectedIndex].$el.classList.remove('selected')
      }
      this.$refs.user[index].$el.classList.add('selected')
      this.lastSelectedIndex = index
      this.selectedUser = user
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";
.user-management {
  display: flex;
  height: 100%;

  &__list {
    width: 250px;
    padding: 40px 22px;
    background-color: #fff;
    border-right: 1px solid map-get($colors, border-color-gray);
    text-align: left;
    overflow: visible;
    /deep/ .search-bar {
      margin: 10px 0 19px 0;
    }
    /deep/ .user-list-item {
      margin-bottom: 12px;
    }
  }
  &__info {
    height: 100%;
    width: 100%;
  }
}
</style>
